/** A chosen file's bytes (FileReader where the browser's Blob has no `arrayBuffer`). */
export async function fileBytes(blob: Blob): Promise<Uint8Array> {
  if (typeof blob.arrayBuffer === 'function') return new Uint8Array(await blob.arrayBuffer());
  return new Uint8Array(
    await new Promise<ArrayBuffer>((ok, fail) => {
      const r = new FileReader();
      r.onload = () => ok(r.result as ArrayBuffer);
      r.onerror = () => fail(r.error ?? new Error('The file could not be read.'));
      r.readAsArrayBuffer(blob);
    }),
  );
}
